export default __webpack_public_path__ + "assets/pdf/RexelCreditApplication.e7a96642.pdf";